import { render, staticRenderFns } from "./RedeemTreasurePage.vue?vue&type=template&id=7cd87b62&scoped=true"
import script from "./RedeemTreasurePage.vue?vue&type=script&lang=js"
export * from "./RedeemTreasurePage.vue?vue&type=script&lang=js"
import style0 from "./RedeemTreasurePage.vue?vue&type=style&index=0&id=7cd87b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd87b62",
  null
  
)

export default component.exports